// Brand colors shared by the boutique wallpaper controls and TOTO collars.
export const BOUTIQUE_BRAND_COLORS = {
 PLT:'#009B3A',FLL:'#0047FF',WYN:'#EF008C',PNC:'#FF6200',RNO:'#F2D000',CC:'#ED1C24',
};
export const CORPORATE_NAVIGATION_COLOR = '#74707c';
